<template>
    <div >

        <!-- 1) add time -->
        <div class="TQ_padding_4px TQ_grid_col_auto1fr ">

            <tq-btn-approve :system-lang-code="p_system_langCode_e"
                            :approve-cb="pe_sendTeamsMedia_f"
                            class="TQ_inline TQ_grid_verticalCenter TQ_margin_8px">
                <tq-image :src="ass_img_send_w"
                          class="TQ_bg_purple TQ_box_shadow TQ_borderRadius TQ_width_24px TQ_padding_8px TQ_clickable TQ_margin_2px TQ_verticalAlignMiddle"
                          :title="ass_strings.threeWords_downloadTeamMedia[p_system_langCode_e]"/>

                <div slot="popup">
                    <div>
                        {{ass_strings.sentence_sendTeamsMedia[p_system_langCode_e]}}
                    </div>
                    <div class="TQ_margin_top_4px TQ_text_bold">
                        {{p_creatorData_c.ud_email_s}}
                    </div>
                </div>

            </tq-btn-approve>

            <!-- time extension -->
            <div class="TQ_margin_8px TQ_grid_verticalCenter TQ_grid_col_1frAuto">

                <div class="TQ_grid_verticalCenter">
                    <div class="TQ_text_12px TQ_align_initial TQ_text_capitalize">
                        {{ ass_strings.threeWords_totalTimeExtensionMinutes[p_system_langCode_e] }}:
                    </div>
                    <input type="number" class="TQ_direction_ltr TQ_width_100p TQ_borderBox TQ_center TQ_padding_4px"
                           @change="m_inputTimeExtension_f"
                           v-model.number="new_timeExtension_n"/>
                    <div class="TQ_text_12px TQ_align_end TQ_text_bold">
                        [<div class="TQ_direction_ltr TQ_inline">{{-p_questEvent_c.qev_durationInMinutes_n}}</div>, {{co_maxTimeExtension_n}}]

                    </div>
                </div>

                <!-- btn -->
                <div class="TQ_width_64px TQ_grid_verticalCenter TQ_align_initial">

                    <div class="TQ_bg_gold_w TQ_padding_4px TQ_verticalAlignMiddle TQ_borderRadius TQ_inline TQ_box_shadow TQ_clickable TQ_margin_4px TQ_inline"
                         @click="m_userEvent_updateGameStatus_f()"
                         v-if="co_showUpdateBtn_timeExtension_b">
                        {{ass_strings.oneWord_update[p_system_langCode_e]}}
                    </div>
                </div>

            </div>

        </div>

        <!-- 2) teams to observe-->
        <div class="TQ_bg_purple_lite TQ_padding_4px TQ_text_20px">
            {{ass_strings.oneWord_teams[p_system_langCode_e]}}
        </div>
        <div class="TQ_padding_8px TQ_height_300px TQ_scrollable">
            <div class="TQ_textAlign_initial TQ_grid_col_1fr1fr ">
                <div v-for="team_c in p_gameStatus_c.gs_teams_byTeamId" class="TQ_inline TQ_margin_8px">

                    <tq-checkbox class="TQ_width_20px TQ_padding_4px TQ_inline"
                                 :p_checked_b="p_selectedObserveTeamsId_as.includes(team_c.gst_teamId_uid)"
                                 @click.native="pe_chooseTeamToObserve_f(team_c.gst_teamId_uid)"/>

                    <div class="TQ_padding_4px TQ_inline"></div>

                    {{team_c.gst_name_s}}

                </div>
            </div>
        </div>

        <hr>

        <!-- btns -->
        <div class="TQ_text_20px TQ_margin_bottom_8px">


            <!-- create new team -->
            <div class="TQ_inline TQ_margin_4px TQ_box_shadow TQ_padding_8px TQ_bg_gold TQ_borderRadius TQ_textColor_white"
                 @click="newTeam_popupShow_vb.val = true" >
                {{ass_strings.twoWords_createTeam[p_system_langCode_e]}}
            </div>

            <!-- 3) creator start quest btn -->
            <div v-if="co_showCreatorStartQuestBtn_b"
                 @click="m_userEvent_creatorStartQuest_f"
                 class="TQ_margin_4px TQ_padding_8px TQ_box_shadow TQ_clickable TQ_bg_green TQ_inline TQ_clickable TQ_borderRadius">
                {{ass_strings.twoWords_startQuest[p_system_langCode_e]}}
            </div>

        </div>

        <!-- popup - create new team -->
        <tq-popup :show="newTeam_popupShow_vb" padding="16px" max-width="300px" :show-close-btn="true">

            <div class="TQ_text_24px">
                {{ass_strings.twoWords_newTeam[p_system_langCode_e]}}
            </div>

            <hr>

            <!-- team name-->
            <input class="TQ_input TQ_fullScreen TQ_padding_8px TQ_margin_bottom_8px"
                   :placeholder="ass_strings.twoWords_TeamName[p_system_langCode_e]"
                   v-model="newTeam_name_s"/>

            <!-- team password-->
            <input class="TQ_input TQ_fullScreen TQ_padding_8px  TQ_margin_bottom_8px"
                   :placeholder="ass_strings.twoWords_teamPassword[p_system_langCode_e]"
                   v-model="newTeam_password_s"/>

            <!-- team color-->
            <tq-pick-color :p_system-lang-code_e="p_system_langCode_e"
                           :pe_change-color_s="(newColor_s) => {this.newTeam_color_s = newColor_s}"
                           class="TQ_margin_bottom_8px"
                           :p_init-color_s="newTeam_color_s">
                <div class="TQ_padding_8px " :style="{'background': newTeam_color_s}">
                    {{ass_strings.twoWords_teamColor[p_system_langCode_e]}}
                </div>
            </tq-pick-color>

            <hr>
            <div class="TQ_bg_green TQ_padding_8px TQ_inline TQ_borderRadius" @click="m_createNewTeam_f">
                {{ass_strings.twoWords_createTeam[p_system_langCode_e]}}
            </div>

        </tq-popup>

    </div>
</template>

<script>
    import {ass_strings} from "../../../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {validator_enum_fb, validator_number_fb} from "../../../../../functions/src/shareCode/Share_S_Validator";
    import {
        enum_accessLevelOptions, enum_featuresMinPoints,
        enum_langCodes, enum_moreInfo_featuresIds_s, enum_moreInfo_helpersIds_s,
        enum_questEventStartClockTypes_s
    } from "../../../../../functions/src/shareCode/Share_S_Enum";
    import TqPickColor from "../../../../components/basic2/TqPickColor";
    import {notification_notify} from "../../../../scripts/S_Notification";
    import TqPopup from "../../../../components/basic/TqPopup";
    import {gv_numbers} from "../../../../../functions/src/shareCode/Share_Ass_GlobalVariable";
    import {
        FB_GameStatus,
        FB_QuestBody,
        FB_QuestEvent,
        FB_UserData
    } from "../../../../../functions/src/shareCode/Share_S_Classes";
    import {date_newDate_fd} from "../../../../scripts/S_Date";
    import TqCheckbox from "../../../../components/basic/TqCheckbox";
    import TqBtnApprove from "../../../../components/basic2/TqBtnApprove";
    import TqImage from "../../../../components/basic/TqImage";
    import {ass_img_send_w} from "../../../../assets/scripts/Ass_Files";
    import {help_maxDurationTime_f} from "../../../../../functions/src/shareCode/Share_S_Helper";

    export default {
        name: "c_Creator_Events_Item_GameStatus",
        components: {TqImage, TqBtnApprove, TqCheckbox, TqPopup, TqPickColor},
        props:{
            p_system_langCode_e:{
                type: String,
                require: true,
                validator(langCode){
                    return validator_enum_fb(enum_langCodes, langCode)
                }
            },
            p_selectedObserveTeamsId_as:{
                type: Array,
                require:true
            },
            p_creatorData_c: {
                require: true,
                type: FB_UserData
            },
            p_gameStatus_c : {
                type : FB_GameStatus,
                require: true
            },
            p_questEvent_c:{
                type : FB_QuestEvent,
                require: true
            },
            p_questBody_c : {
                type : FB_QuestBody,
                require: true
            },
            p_currentUserData_c:{
                type : FB_UserData,
                require: true
            },
            pe_chooseTeamToObserve_f:{
                type : Function,
                require: true
            },
            pe_server_createNewTeam_f:{
                type : Function,
                require: true
            },
            pe_server_updateGameStatus_timeExtensions_f:{
                type : Function,
                require: true
            },
            pe_server_updateGameStatus_creatorSetStartTime_f:{
                type : Function,
                require: true
            },
            pe_sendTeamsMedia_f:{
                type: Function,
                require: true
            }

        },
        data(){
            return {
                ass_strings : ass_strings,
                ass_img_send_w : ass_img_send_w,
                new_timeExtension_n  : this.p_gameStatus_c.gs_timeExtensionMinutes_n,

                newTeam_popupShow_vb : {val : false},
                newTeam_name_s      : "",
                newTeam_password_s  : "",
                newTeam_color_s     : "#add8e6",
            }
        },
        computed:{
            co_showUpdateBtn_timeExtension_b(){

                return this.p_gameStatus_c.gs_timeExtensionMinutes_n !== this.new_timeExtension_n
            },

            co_showCreatorStartQuestBtn_b(){

                let playerStartClock_b = [enum_questEventStartClockTypes_s.creatorStartClock]
                    .includes(this.p_questEvent_c.qev_startClockType_e)

                let creatorStartedClock_b = this.p_gameStatus_c.gs_creatorStartTime_t != null

                return playerStartClock_b && !creatorStartedClock_b
            },
            co_allTeamsIds_as(){
                return []
            },
            co_maxTimeExtension_n(){
                return gv_numbers.maxTimeExtension
            }
        },
        methods:{
            m_userEvent_creatorStartQuest_f(){
                let nowTime_t = date_newDate_fd().getTime()

                this.pe_server_updateGameStatus_creatorSetStartTime_f(this.p_questEvent_c, nowTime_t, () => {})
            },
            m_userEvent_updateGameStatus_f(){

                this.pe_server_updateGameStatus_timeExtensions_f(this.p_questEvent_c, this.new_timeExtension_n, () =>{})
            },
            m_inputTimeExtension_f(){

                if(!validator_number_fb(this.new_timeExtension_n)){
                    this.new_timeExtension_n = 0
                }

                if(this.new_timeExtension_n > this.co_maxTimeExtension_n){
                    this.new_timeExtension_n = this.co_maxTimeExtension_n
                }else if(this.new_timeExtension_n < -this.p_questEvent_c.qev_durationInMinutes_n){
                    this.new_timeExtension_n = -this.p_questEvent_c.qev_durationInMinutes_n
                }
            },

            // createNewTeam
            m_createNewTeam_f(){

                if(this.newTeam_name_s === ''){
                    notification_notify(ass_strings.oneWord_error, ass_strings.fourWords_pleaseChooseTeamName, null)
                    return
                }
                if(!this.newTeam_password_s){
                    notification_notify(ass_strings.oneWord_error, ass_strings.fourWords_pleaseChooseTeamPassword, null)
                    return
                }
                if(this.newTeam_password_s.length < gv_numbers.passwordMinLength){
                    notification_notify(ass_strings.oneWord_error, ass_strings.sentence_password6Chars, null)
                    return
                }
                if(!this.newTeam_color_s){
                    notification_notify(ass_strings.oneWord_error, ass_strings.fourWords_pleaseChooseTeamColor, null)
                    return
                }


                // if(this.selectedStartingRiddleIndex === null && this.supportStartingRiddleRiddle){
                //     notification_notify(ass_strings.oneWord_error, ass_strings.sentence_pleaseChooseStartingRiddle, null)
                //     return
                // }


                this.pe_server_createNewTeam_f(this.p_questEvent_c, this.p_questBody_c, this.newTeam_name_s, this.newTeam_color_s, this.newTeam_password_s, null, null, () => {
                    notification_notify(ass_strings.threeWords_createdNewTeam)
                });

                this.newTeam_color_s    = "#add8e6"
                this.newTeam_name_s     = ""
                this.newTeam_password_s = ""
                this.newTeam_popupShow_vb.val = false
            },
        }
    }

</script>

<style scoped>

</style>